import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import styled from "styled-components";

import { topBarBackgroundColor } from "../Colors";

export const TopBar = styled.div<{
  $isLoggedIn?: boolean;
}>`
  display: flex;
  align-self: stretch;
  background: ${topBarBackgroundColor};
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 16px 20px 8px 20px;
`;

export const MenuContainer = styled.div<{ $height?: number }>`
  position: fixed;
  top: 60px;
  height: calc(100% - 60px);
  left: 0;
  z-index: 1;
  width: 100vw;
  background: white;
  display: flex;
  flex-direction: column;
  transition: opacity 0.05s linear;

  ${responsiveMediaQueries.mobile} {
    top: 50px;
    height: calc(100% - 50px);

    &.with-promo-banner {
      top: ${(props) => (props.$height ?? 0) + 50}px;
      height: calc(100% - ${(props) => (props.$height ?? 0) + 50}px);
    }
  }

  ${responsiveMediaQueries.tablet} {
    &.with-promo-banner {
      top: 95px;
      height: calc(100% - 95px);
    }
  }
`;
